"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOLDER = exports.FILES = void 0;
const FILES = 'file_based_collection';
exports.FILES = FILES;
const FOLDER = 'folder_based_collection';
exports.FOLDER = FOLDER;